import ModalContainer from "../../Tanda Terima/containers/ModalContainer";
import DetailTandaTerima from "./DetailTandaTerima";

const ModalDetailTandaTerima = ({ data, toggle, isOpen }) => {
  return (
    <ModalContainer 
      title="Detail Tanda Terima" 
      isOpen={isOpen} 
      toggle={toggle}
    >
      <DetailTandaTerima data={data} toggle={toggle} />
    </ModalContainer>
  );
};

export default ModalDetailTandaTerima;
